export default {
      id: "more-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#more",
      toString: function () {
        return this.url;
      }
    }